import React from "react";

const Header = ({ userType }) => {
  // Header is now empty - skills badge moved to TopNavigation
  return null;
};

export default Header;

